<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card dark>
      <v-card-title>
        <span class="text-h5">Trainingsanfrage an {{ userName }}</span>
      </v-card-title>
      <v-card-text>
        <p>Wähle die Tage aus, an denen du trainieren möchtest.</p>
        <v-chip-group v-model="availability.days" column multiple active-class="primary--text">
          <v-chip v-for="day in weekDays" :key="day" :value="day" filter outlined>
            {{ day }}
          </v-chip>
        </v-chip-group>
        <v-select
          v-model="availability.timeOfDay"
          :items="times"
          label="Bevorzugte Tageszeit"
          dark
          filled
          rounded
          hide-details
          class="mt-4"></v-select>
        <v-textarea
          v-model="message"
          label="Deine Nachricht (optional)"
          placeholder="Hey! Lust zusammen zu trainieren?"
          dark
          filled
          rounded
          auto-grow
          rows="2"
          class="mt-6"
          counter="200"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Abbrechen</v-btn>
        <v-btn color="primary" :loading="loading" :disabled="availability.days.length === 0" @click="send"> Anfrage Senden </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  props: {
    value: Boolean, // dialog control
    user: Object, // { _id, vorname }
  },
  data: () => ({
    loading: false,
    availability: {
      type: "recurring",
      days: [],
      timeOfDay: "Abends",
    },
    message: "",
    weekDays: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
    times: ["Morgens", "Mittags", "Nachmittags", "Abends"],
  }),
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
    userName() {
      return this.user ? this.user.vorname : ""
    },
  },
  methods: {
    close() {
      this.dialog = false
    },
    async send() {
      this.loading = true
      try {
        await api.social.createTrainingRequest({
          recipientId: this.user._id,
          availability: this.availability,
          message: this.message,
        })
        this.$emit("sent") // Event für Erfolgsmeldung
        this.close()
      } catch (error) {
        // Fehler anzeigen
        console.error(error)
        alert(error.response?.data?.message || "Senden fehlgeschlagen.")
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
